import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";

import { Dropdown } from "../../../components/dropdown/Dropdown";
import { ProjectCodeSystem } from "../../../services/project/ProjectCodeSystem";
import FormField from "../../../components/form-field/FormField";
import { RequiredOptionValidatorModel } from "../../../services/form/validators/required/RequiredOptionValidator";

interface EditProjectCodeSystemProps {
  value?: ProjectCodeSystem;
  codeSystems: ProjectCodeSystem[];
  onChange: (codeSystem: ProjectCodeSystem) => void;
  setFieldValue: Function;
  disabled: boolean;
}

export const EditProjectCodeSystem = observer((props: EditProjectCodeSystemProps) => {
  const { value, onChange, codeSystems, setFieldValue, disabled } = props;
  const [requiredOptionValidator] = useState(() =>
    RequiredOptionValidatorModel.create({ option: value })
  );

  useEffect(() => {
    requiredOptionValidator.set(value);
  }, [requiredOptionValidator, value]);

  const options = codeSystems.map((x) => ({ ...x, id: x.id, name: x.name }));

  return (
    <FormField
      id="project-code-system"
      labelKey={"general.project.codeSystem"}
      fieldName="codeSystem"
      fieldValue={value}
      validator={requiredOptionValidator}
      required
      disabled={disabled}
      children={() => (
        <div className="form-element-container">
          <Dropdown
            selectedOption={value && value.name ? value : null}
            options={options}
            onChange={onChange}
            disabled={disabled}
            fieldName="codeSystem"
            setFieldValue={setFieldValue}
            placeholderKey="EditProject.code-system.selection"
          />
        </div>
      )}
      errorName="codeSystem"
    />
  );
});
